module.exports = {
  _close: function () {
    INKIVE.Helpers.api(
      'inkive/close', 'GET',
      { scrapbook: INKIVE.C.BOOK.id },
      _.bind(onClose, this)
    );

    function onClose () {
      this.isClosing = false;
      INKIVE.Modal.togglePageLoader(false);
      this.appBridge.callBoth('close_editor');
    }
  }
};
